import styled from 'styled-components';

export const Template = styled.div`
    min-height: 100vh;
`;



// WEBPACK FOOTER //
// ./src/components/template/TemplateStyle.js